import { render, staticRenderFns } from "./WindowStack.vue?vue&type=template&id=7c1db950&"
import script from "./WindowStack.vue?vue&type=script&lang=js&"
export * from "./WindowStack.vue?vue&type=script&lang=js&"
import style0 from "./WindowStack.vue?vue&type=style&index=0&id=7c1db950&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports